import React from 'react'
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaReact } from "react-icons/fa";
import { SiTailwindcss, SiFigma, SiNextdotjs } from "react-icons/si";
const Media = () => {
  return (
    <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            Find me in
          </h2>
          <div className="flex gap-4">
            {/* <span className="bannerIcon">
              <FaFacebookF />
            </span>
            <span className="bannerIcon">
              <FaTwitter />
            </span>
            <span className="bannerIcon">
              <FaLinkedinIn />
            </span> */}
            <span className="bannerIcon">
              <a href="https://www.facebook.com/profile.php?id=100011818511936" target="_blank" rel="noopener noreferrer" className="bannerIcon">
              <FaFacebookF />
              </a>
            </span>
            <span className="bannerIcon">
              <a href="https://www.instagram.com/sairajesh_1610/" target="_blank" rel="noopener noreferrer" className="bannerIcon">
              <FaInstagram />
              </a>
            </span>
            <span className="bannerIcon">
              <a href="https://www.linkedin.com/in/sairajeshjaini/" target="_blank" rel="noopener noreferrer" className="bannerIcon">
              <FaLinkedinIn />
              </a>
            </span>
          </div>
        </div>
        {/* <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            BEST SKILL ON
          </h2>
          <div className="flex gap-4">
            <span className="bannerIcon">
              <FaReact />
            </span>
            <span className="bannerIcon">
              <SiNextdotjs />
            </span>
            <span className="bannerIcon">
              <SiTailwindcss />
            </span>
            <span className="bannerIcon">
              <SiFigma />
            </span>
          </div>
        </div> */}
      </div>
  )
}

export default Media